import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { envConfigs } from '../../../envConfigs';
import { version } from '../../../../package.json';

// I knocked this down to Dev 25% and QA 10% because we actually get more RUM hits from QA
// automated testing than from Prod
// WD Mar 2022
const sampleRate = envConfigs.env === 'prod' ? 10 : envConfigs.env === 'dev' ? 12 : 5;

datadogLogs.init({
  clientToken: 'pub81da76b3a032ea5b36b1d3da08c252a0',
  site: 'datadoghq.com',
  forwardErrorsToLogs: true,
  sampleRate: sampleRate,
  env: envConfigs.env,
  version: version
});

datadogRum.init({
  applicationId: 'd0a84a76-1e13-4bde-bb62-f0ebc599fce2',
  clientToken: 'pubd95003e8598bd2e056b6fd42aa44a1dd',
  site: 'datadoghq.com',
  service: 'launchpad',
  env: envConfigs.env,
  version: version,
  sampleRate: sampleRate,
  trackInteractions: true
});



// WEBPACK FOOTER //
// ./src/modules/app/services/init-data-dog.js